import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalBuscarTrabajadorPageRoutingModule } from './modal-buscar-trabajador-routing.module';

import { ModalBuscarTrabajadorPage } from './modal-buscar-trabajador.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalBuscarTrabajadorPageRoutingModule
  ],
  declarations: [ModalBuscarTrabajadorPage]
})
export class ModalBuscarTrabajadorPageModule {}
